import type { DefaultDashboardDefinition } from './dashboard-definition';

export const pointOfSaleDashboard: DefaultDashboardDefinition = {
  id: "point-of-sale.main",
  appId: "point-of-sale",
  name: "Point Of Sale dashboard",
  record: null,
  queryScope: null,
  placements: [
    {
      id: "pos.sales-trend.default",
      widgetId: "pos.sales-trend",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "pos.payment-trend.default",
      widgetId: "pos.payment-trend",
      placement: {
        x: 6,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "pos.order-count.default",
      widgetId: "pos.order-count",
      placement: {
        x: 0,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "pos.sales.default",
      widgetId: "pos.sales",
      placement: {
        x: 4,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "pos.active-sessions.default",
      widgetId: "pos.active-sessions",
      placement: {
        x: 8,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "pos.status-list.default",
      widgetId: "pos.status-list",
      placement: {
        x: 0,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "pos.payment-report.default",
      widgetId: "pos.payment-report",
      placement: {
        x: 6,
        y: 4,
        width: 6,
        height: 4,
      },
    },
  ],
};
